import type { NPCConfig } from '@/entities';

const config: NPCConfig[] = [
  {
    x: 1850,
    y: 1530,
    name: 'Elsa',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_elsa.png', // Use NPC image
    repeatable : false,
    flipSprite : true,
    dialogTree: {
      startDialogId: 'elsa_1',
      nodes: {
        elsa_1: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Yan! Ya ampun tolong Yan!`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "elsa_2",
        },
        elsa_2: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Cepat cari bantuan!`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "elsa_3",
        },
        elsa_3: {
          id: 'elsa_1',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          choices: [
            {
              text: 'Elsa, tenang, ada apa?',
              nextDialogId: 'elsa_4',
            },
            {
              text: 'Apa yang terjadi Elsa?',
              nextDialogId: 'elsa_4',
            },
          ],
        },
        elsa_4: {
          id: 'elsa_4',
          speaker: 'Elsa',
          text: `Sebaiknya kamu masuk kedalam.`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId: 'part1_b1',
        },
        part1_b1: {
          id: 'part1_4',
          speaker: '',
          text: ``,
          backgroundImage: '/assets/cutscene/black.png',
          nextDialogId: 'part1_b2',
          sfx: "running"
        },
        part1_b2: {
          id: 'part1_4',
          speaker: '',
          text: ``,
          backgroundImage: '/assets/cutscene/death_diana.jpg',
          nextDialogId: 'part1_b4',
          sfx : "orchestraFreak"
        },
        part1_b4: {
          id: 'part1_4',
          speaker: 'Yan',
          text: `Apa yang harus aku lakukan`,
          backgroundImage: '/assets/cutscene/death_diana.jpg',
          choices: [
            {
              text: 'Teriak meminta tolong',
              nextDialogId: 'part1_c1',
            },
            {
              text: 'Tenang dan investigasi',
              nextDialogId: 'part1_d1',
            },
          ],
        },
        part1_c1: {
          id: 'part1_4',
          speaker: 'Yan',
          text: `Tolong!!!!`,
          backgroundImage: '/assets/cutscene/death_diana.jpg',
          characterImage: '/assets/character/v2/yanf.png',
          nextDialogId: 'part1_c2',
        },
        part1_c2: {
          id: 'part1_4',
          speaker: 'Yan',
          text: `Tolong!!!!`,
          backgroundImage: '/assets/cutscene/death_diana.jpg',
          characterImage: '/assets/character/v2/yanf.png',
          nextDialogId: 'part1_c3',
        },
        part1_c3: {
          id: 'part1_4',
          speaker: 'Elsa',
          text: `Sepertinya tidak ada siapa-siapa.`,
          backgroundImage: '/assets/cutscene/death_diana.jpg',
          characterImage: '/assets/character/v2/elsa.png',
          nextDialogId: 'part1_c4',
        },
        part1_c4: {
          id: 'part1_4',
          speaker: '',
          text: `Mungkin saatnya tenang dan coba kita analisa situasi ini`,
          backgroundImage: '/assets/cutscene/death_diana.jpg',
          characterImage: '/assets/character/v2/yanf.png',
          nextDialogId: 'part1_d1',
        },
        part1_d1: {
          id: 'part1_4',
          speaker: '',
          text: `Bagian apa yang ingin di investigasi`,
          backgroundImage: '/assets/cutscene/death_diana.jpg',
          nextDialogId : 'part1_g1',
          clickables : [
            {
              text: 'Tumpahan Darah',
              nextDialogId: 'part1_e1',
              locationX : 75, locationY : 70
            },
            {
              text: 'Kondisi badan Diana',
              nextDialogId: 'part1_f1',
              locationX : 37, locationY : 65
            },
            {
              text: 'Barang di lantai',
              nextDialogId: 'part1_h1',
              locationX : 76, locationY : 26,
            },
          ]
        },

        part1_h1: {
          id: 'part1_h1',
          speaker: '',
          text: `Di lantai ini, adalah buku. Sepertinya aku pernah melihat buku ini sebelumnya.`,
          backgroundImage: '/assets/cutscene/death_diana.jpg',
          nextDialogId: 'part1_h2',
        },
        part1_h2: {
          id: 'part1_h1',
          speaker: '',
          text: `Buku cukup tebal, seperti kamus atau alkitab.`,
          backgroundImage: '/assets/cutscene/death_diana.jpg',
          nextDialogId: 'part1_h3',
        },
        part1_h3: {
          id: 'part1_h1',
          speaker: '',
          text: `Sisi keras buku terlihat penyok seperti dipakai untuk memukul.`,
          backgroundImage: '/assets/cutscene/death_diana.jpg',
          nextDialogId: 'part1_d1',
        },

        part1_e1: {
          id: 'part1_e1',
          speaker: '',
          text: `Darah masih mengalir dan menetes ke lantai`,
          backgroundImage: '/assets/cutscene/death_diana_blood_zoom.png',
          nextDialogId: 'part1_e2',
        },
        part1_e2: {
          id: 'part1_e1',
          speaker: '',
          text: `Sepertinya darah masih baru, belum ada darah yang kering`,
          backgroundImage: '/assets/cutscene/death_diana_blood_zoom.jpg',
          nextDialogId: 'part1_d1',
        },
        part1_f1: {
          id: 'part1_f1',
          speaker: '',
          text: `Kondisi badan kering, serupa dengan kematian Sondakh`,
          backgroundImage: '/assets/cutscene/death_diana.jpg',
          nextDialogId: 'part1_d1',
        },
        part1_g1: {
          id: 'part1_g1',
          speaker: 'Yan',
          text: `Sebaiknya kita keluar mencari bantuan`,
          backgroundImage: '/assets/cutscene/death_diana.jpg',
          nextDialogId : "op1",
        },

        op1: {
          id: 'op1',
          speaker: 'Romo Darius',
          text: `Saya datang kesini karena mendengar keributan. Ada apa?`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "op2"
        },
        op2: {
          id: 'op1',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/desa.png',
          choices: [
            {
              text: 'Kami menemukan Diana meninggal di kamar.',
              nextDialogId: 'op3',
            },
            {
              text: 'Diana sudah meninggal...',
              nextDialogId: 'op3',
            },
          ],
        },
        op3: {
          id: 'op3',
          speaker: 'Nenek',
          text: `Apa yang terjadi dengan Diana?`,
          characterImage: '/assets/character/v2/nenek.png',//TODO nenek keriput ilang
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "op4"
        },
        op4: {
          id: 'op4',
          speaker: 'Nenek',
          text: `Elsa! Apa yang terjadi? `,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "op5"
        },
        op5: {
          id: 'op4',
          speaker: 'Nenek',
          text: `Bukannya kamu satu kamar dengan Diana?`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "op6"
        },
        op6: {
          id: 'op6',
          speaker: 'Elsa',
          text: `Aku sedang di toilet saat ini terjadi. Aku sumpah`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "op7"
        },
        op7: {
          id: 'op',
          speaker: 'Elsa',
          text: `Aku tidak melakukan apa-apa!`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "op8"
        },
        op8: {
          id: 'op',
          speaker: 'Ato',
          text: `Jangan bohong kamu. Sudah banyak kejadian dari kemarin.`,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "op9"
        },
        op9: {
          id: 'op',
          speaker: 'Ato',
          text: `Ayo tangkap dia!`,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "op10"
        },
        op10: {
          id: 'op10',
          speaker: 'Romo Darius',
          text: `Cukup Ato!`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "op11"
        },
        op11: {
          id: 'op10',
          speaker: 'Romo Darius',
          text: `Di saat seperti ini, kita harus saling membantu.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "op12"
        },
        op12: {
          id: 'op10',
          speaker: 'Romo Darius',
          text: `Bantu bawakan Diana ke gereja agar bisa cepat kita doakan.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "op13"
        },
        op13: {
          id: 'op12',
          speaker: 'Ato',
          text: `Maaf Romo, baiklah`,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "op14"
        },
        op14: {
          id: 'op14',
          speaker: 'Romo Darius',
          text: `Nenek, dan Yan, mari kita bertemu di Gereja, dan doakan Diana bersama.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/desa.png',
          storyAction: { type: 'nextDay', value: 1 },
          isEnd : true
        },

      },
    },
  },
];

export default config;
